export default {
    state: {
        zipList: []
    },
    mutations: {
        SET_ZIP_ITEM(state, zip) {
            state.zipList = state.zipList.filter(item => !item.success)
            state.zipList.push(zip)
        },
        REFRESH_ITEMS(state) {
            state.zipList = state.zipList.filter(item => !item.success)
        }
    },
    actions: {
        pushZip({ commit }, data) {
            commit('SET_ZIP_ITEM', data)
        },
        refreshZip({ commit }) {
            commit('REFRESH_ITEMS')
        }
    }
}